import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { ADMIN_USER_ACCESS } from '../../../constant/FrontEnd';
import { getUserData, checkUserAccessAndToken, getHeaderForAxios } from '../../../common/getLocalStorageData';
import { Redirect } from 'react-router-dom';

function Dashboard() {
    const userId = getUserData();
    const [allDealData, setAllDealData] = useState<any[]>([])
    const accessAdminDashboard = checkUserAccessAndToken(ADMIN_USER_ACCESS);

    const [toggleFlag, setToggleFlag] = useState(true);

    let fetchData = async () => {
        let data: any = { user_uuid: userId };
        let selectedUuid = "";
        await Axios.post(process.env.REACT_APP_API_URL + "/admin/getDashboardData/deal", data, { headers: getHeaderForAxios() })
            .then(function (response) {
                if (response.data && response.data.success) {
                    console.log("test >>", response.data.success)
                    // let getDropDownData = [];
                    // let getSponsorData = [];
                    // let winnerData = [];
                    // let allDealData = [];
                    // let countData = [];
                    // if (response.data.success.dropDown) {
                    //     getDropDownData = response.data.success.dropDown;
                    // }
                    // if (response.data.success.sponserData) {
                    //     getSponsorData = response.data.success.sponserData;
                    //     selectedUuid = response.data.success.sponserData['sponsor_uuid'];
                    // }
                    // if (response.data.success.allWinnerData) {
                    //     winnerData = response.data.success.allWinnerData;
                    // }
                    // if (response.data.success.allDealData) {
                    //     allDealData = response.data.success.allDealData;
                    // }
                    // if (response.data.success.countData) {
                    //     countData = response.data.success.countData;
                    // }
                    // setSelectedDropDown(selectedUuid);
                    // setAllDealData(allDealData);
                    // setWinnerData(winnerData);
                    // setDropDown(getDropDownData);
                    // setSponsorData(getSponsorData);
                    // setCountData(countData);
                    // setToggleFlag(!toggleFlag)
                    // if (selectedUuid)
                    //     localStorage.setItem("selectedSponsorByStore", JSON.stringify(EncryptData(selectedUuid)));
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
    }

    let getDataFunction = () => {
        fetchData()
    }

    useEffect(() => {
        if (accessAdminDashboard) {
            getDataFunction()
        }
    }, []);

    // const displayRedeemModal = (certificateData: object) => {
    //     if (certificateData) {
    //         setModalCertificateFlag(true)
    //         setModalCertificateData(certificateData)
    //         setToggleFlag(!toggleFlag)
    //     }
    // }

    // const hideRedeemModal = () => {
    //     setModalCertificateData({})
    //     setModalCertificateFlag(false)
    // }


    // const onRedeemedOffer = async (pin: number) => {
    //     if (modalCertificateData) {
    //         let data = {
    //             user_uuid: userId,
    //             alphacode_uuid: modalCertificateData?.alphacode_uuid ? modalCertificateData?.alphacode_uuid : "",
    //             code: modalCertificateData?.winner_award_code ? modalCertificateData?.winner_award_code : "",
    //             pin: pin
    //         }
    //         await Axios.post(process.env.REACT_APP_API_URL + "/store/setRedeemedOffer", data, { headers: getHeaderForAxios() })
    //             .then(function (response) {
    //                 console.log("rr >>", response)
    //                 getDataFunction()
    //                 hideRedeemModal()
    //             })
    //             .catch(function (error) {
    //                 // handle error
    //                 console.log(" gg ??", error);
    //                 //hideRedeemModal()
    //             })
    //     }
    // }

    return (
        <>
            {accessAdminDashboard ?
                <div className="main-container" key={toggleFlag ? "1" : "0"}>
                    {/* <StoreDetail dropDown={dropDown} selectedDropDown={selectedDropDown} sponsorData={sponsorData} refreshData={onChangeSponsorDropDown} />
                    <CountDetail countData={countData} />
                    <WinnerTable winnerData={winnerData} hideRedeemModal={() => hideRedeemModal()} displayRedeemModal={(cNumber: object) => displayRedeemModal(cNumber)} />
                    {
                        modalCertificateFlag ?
                            <RedeemAward certificateData={modalCertificateData} onSubmit={(pin: number) => onRedeemedOffer(pin)} />
                            : ""
                    } */}
                </div>
                : <Redirect to="/404" />}
        </>
    )
}

export default Dashboard
